export const undoubleSortList = (list: any[], property: string) => {
    const seen = new Set();
    const unique = list.filter(item => {
        const value = item[property];
        if (seen.has(value)) return false;
        seen.add(value);
        return true;
    });

    return unique.sort((a, b) => {
        if (a[property] < b[property]) return -1;
        if (a[property] > b[property]) return 1;
        return 0;
    });
};

